import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EMPTY, map, Observable, switchMap} from 'rxjs';
import {FileUploadService} from '../../common/services/file-upload.service';
import {environment} from '../../../../environments/environment';
import {ApplicationDocumentDTO, DocumentTableDTO} from '../models/application/ApplicationDocumentDTO';
import {ReferenceDTO} from '../models/application/ReferenceDTO';
import {catchError} from 'rxjs/operators';
import {NameValueCodeDTO} from '../../common/models/NameValueCodeDTO';
import {FileDTO} from '../../clm/models/FileDTO';

@Injectable({
  providedIn: 'root'
})
export class ApplicationDocumentFileService {
  private readonly documentUrl = environment.baseUrl + '/application-onboard/document';
  private readonly fileAttachUrl = environment.baseIgnUrl + '/application-onboard/attach-file';
  private readonly referenceUrl = environment.baseUrl + '/reference';

  constructor(
    private http: HttpClient,
    private fileUploadService: FileUploadService,
  ) {
  }

  getDocumentTypes(fieldName: string): Observable<NameValueCodeDTO[]> {
    const url = `${this.referenceUrl}/all?fieldName=${fieldName}`;
    return this.http.get<ReferenceDTO[]>(url, {
      params: {
        fieldName: 'documentTypeCode'
      }
    }).pipe(
      map((references: ReferenceDTO[]) =>
        references.map((ref: ReferenceDTO) => ({
          name: ref.value,
          value: Number(ref.referenceId),
          code: ref.key,
        }))
      )
    );
  }

  linkDocumentToPerson(file: FileDTO, applicationIdentifier: number, personIdentifier: string, documentTypeCode: string): Observable<ApplicationDocumentDTO> {
    return this.http.post<ApplicationDocumentDTO>(
      `${this.fileAttachUrl}?applicationIdentifier=${applicationIdentifier}&personIdentifier=${personIdentifier}&documentTypeCode=${documentTypeCode}`,
      file
    );
  }

  /**
   * Deletes the document link first and then the associated file
   * @param applicationDocumentId The ID of the document link to delete
   * @param documentReferenceNumber The reference number of the file to delete
   */
  deletePerDocumentWithFile(document: DocumentTableDTO): Observable<void> {
    const documentId = document.applicationDocumentId;
    const applicationPersonId = document.applicationPersonId;
    const documentReferenceNumber = document.documentReferenceNumber;

    return this.http.delete(`${this.documentUrl}?applicationPersonId=${applicationPersonId}&documentId=${documentId}`)
      .pipe(
        switchMap(() => this.fileUploadService.deleteFile(Number(documentReferenceNumber))),
        catchError(error => {
          return EMPTY;
        })
      );
  }

  base64toBlob(base64Data: string, contentType: string): Blob {
    return this.fileUploadService.base64toBlob(base64Data, contentType);
  }

  downloadFileByReferenceNumber(documentReferenceNumber: string, fileName?: string): void {
    this.fileUploadService.downloadFile(documentReferenceNumber, null);
  }
}
